<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,802.5l-2.73-2.73h5.45L0.5,802.5z M-4.05,797.95l-1.82-1.82h2.73l1.82,1.82H-4.05z M2.32,797.95l1.82-1.82h2.73
	l-1.82,1.82H2.32z M-7.68,794.32l-1.82-1.82l1.82-1.82h2.73l-1.82,1.82l1.82,1.82H-7.68z M5.95,794.32l1.82-1.82l-1.82-1.82h2.73
	l1.82,1.82l-1.82,1.82H5.95z M-5.86,788.86l1.82-1.82h2.73l-1.82,1.82H-5.86z M4.14,788.86l-1.82-1.82h2.73l1.82,1.82H4.14z
	 M-2.23,785.23l2.73-2.73l2.73,2.73H0.5H-2.23z"/>
</svg>

</template>